import ApplicationController from '../application_controller.js'
import axios from 'axios'

export default class IndexController extends ApplicationController {

  static targets = [
    ""
  ]

  destroy(e) {
    e.preventDefault()
    this.confirm(e.target.dataset.confirmText, reason => {
      if (reason.confirm) {
        axios.delete(e.target.getAttribute('href')).then(() => {
          this.reload_page()
        })
      }
      reason.close_modal()
    })
  }

}